<div class="dialog-content-wrapper">
    <div mat-dialog-content>
        <img
            alt="Google Maps Plus Code"
            src="../assets/images/map-guide.png"
        />
    </div>
</div>
